import { RootState } from "../app/Store";
import { ProductType } from "./Models";

const getSiteProducts = (state: RootState, siteId: string) =>
  state.purchasedProducts?.productsBySite[siteId];

export const isMonitoringOnlyProducts = (products: readonly ProductType[] | undefined): boolean =>
  products?.includes(ProductType.MonitorOnly) === true &&
  !products.includes(ProductType.Tracs) &&
  !products.includes(ProductType.Soma);

export const isMonitoringOnlySite = (state: RootState, siteId: string): boolean => {
  return isMonitoringOnlyProducts(getSiteProducts(state, siteId));
};
